/*
 *==================================================
 * Licensed Materials - ADIACENT
 *
 * user roles (mroService.getRoles) held in redux state
 *
 *==================================================
 */
//Standard libraries
import { createAction } from "@reduxjs/toolkit";
//Redux
import * as ACTIONTYPES from "../action-types/userRoles";

export const USER_ROLES_GET_REQUESTED_ACTION = createAction<any, string>(
  ACTIONTYPES.USER_ROLES_GET_REQUESTED
);

export const USER_ROLES_GET_SUCCESS_ACTION = createAction<any, string>(
  ACTIONTYPES.USER_ROLES_GET_SUCCESS
);

export const USER_ROLES_RESET_ACTION = createAction<any, string>(
  ACTIONTYPES.USER_ROLES_RESET
);
